import { render } from "./InvoiceEdit.vue?vue&type=template&id=bb2c4768&scoped=true&ts=true"
import script from "./InvoiceEdit.vue?vue&type=script&lang=ts"
export * from "./InvoiceEdit.vue?vue&type=script&lang=ts"

import "./InvoiceEdit.vue?vue&type=style&index=0&id=bb2c4768&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb2c4768"]])

export default __exports__